module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA7SURBVDhPYxhU4D8BTBDgU9QBpfECdAOQbceGMQC6IFZFUDBqAC0NgOF2KI0L4JODA6oYgA8PCsDAAADF3TPdRWn7WwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Grey/Copy16.png
// module id = 672
// module chunks = 0